import { Route, Routes, useLocation, useNavigate } from "react-router-dom";
import { NavItems } from "@helpers/navigation";
import { AdminShell } from "@fadmin/components/AdminShell";
import { ManageExaminees } from "./manageExaminees";
import { AccountLocationDetails } from "./AccountLocationDetails";
import { ManageOverview } from "./manageOverview";
import { ManageStaff } from "./manageStaff";
import { GoBack } from "@fadmin/components/GoBack";
import { ManageNav } from "../components/manageNav";
import { AuthenticatedRoute } from "@components/AuthenticatedRoute";
import { RoleId } from "@store/generalTypes";
import { RolesPermissions } from "./rolesPermissions";

export const ManageLanding = (): JSX.Element => {
    const { pathname } = useLocation();
    const navigate = useNavigate();

    const handleGoBack = (): void => {
        navigate(NavItems.Admin.Manage.Overview.path);
    };

    const routes = (
        <>
            <AuthenticatedRoute roles={[RoleId.Admin, RoleId.Facilitator]} autoRedirect={false}>
                <Routes>
                    <Route path="*" element={<ManageOverview />} />
                    <Route
                        path={NavItems.Admin.Manage.LocationDetails.relativePath}
                        element={<AccountLocationDetails />}
                    />
                    <Route path={NavItems.Admin.Manage.Staff.relativePath} element={<ManageStaff />} />
                    <Route path={NavItems.Admin.Manage.Examinees.relativePath} element={<ManageExaminees />} />
                    <Route
                        path={NavItems.Admin.Manage.RolesAndPermissions.relativePath}
                        element={<RolesPermissions />}
                    />
                </Routes>
            </AuthenticatedRoute>
        </>
    );

    // TODO: when necessary, abstract this
    const nav =
        pathname === NavItems.Admin.Manage.LocationDetails.path ? (
            <GoBack onClick={handleGoBack} title="Back to Account Overview" />
        ) : (
            <ManageNav />
        );

    return <AdminShell routes={routes} nav={nav} />;
};
